export default __webpack_public_path__ + "static/media/SokhnaLovelace.6a33ef26.png";